import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { authInterceptor } from '../../core/auth/auth.interceptor';
import { AuthService } from '../../core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [provideHttpClient(withXhr(), withInterceptors([authInterceptor])), provideEnvironmentInitializer(() => inject(AuthService))];
};
